export const generateDuplicateScenarioName = (
  sourceName: string,
  existingNames: string[]
): string => {
  const normalizedExisting = new Set(
    existingNames
      .map((name) => name.trim().toLowerCase())
      .filter(Boolean)
  );

  const baseName = sourceName.trim() || 'Scenario';
  const firstCandidate = `${baseName} (copy)`;
  if (!normalizedExisting.has(firstCandidate.toLowerCase())) {
    return firstCandidate;
  }

  let copyNumber = 2;
  while (normalizedExisting.has(`${baseName} (copy ${copyNumber})`.toLowerCase())) {
    copyNumber += 1;
  }

  return `${baseName} (copy ${copyNumber})`;
};

export const cloneScenarioConfiguration = (configuration: Record<string, any>): Record<string, any> => {
  return JSON.parse(JSON.stringify(configuration ?? {}));
};
